window.dataLayer = window.dataLayer || [];

$(window.document).on('action', function(event, eventobj) {
    eventobj = $.extend({
        'ts': event.timeStamp,
        'event': eventobj.event_type // define actual trigger event for GTM
    }, eventobj);
    window.dataLayer.push(eventobj);
});



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/engagement-handler/gtm-engagement-handler/gtm-engagement-handler.js
// module id = 435
// module chunks = 36